'use client'

import { shopAsset } from '@utils/utils-config'
import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const shop = {
  logo: {
    lightSrc: shopAsset('/images/7fridays-logo-green.svg'),
    darkSrc: shopAsset('/images/7fridays-logo-white.svg'),
    darkShortSrc: shopAsset('/images/7f-logo-dark-short.svg'),
    fallbackSrc: shopAsset('/images/7f-logo-fallback.svg'),
    bikeFallbackSrc: shopAsset('/images/bike-fallback.jpg'),
  },
  search: {
    emptyList: shopAsset('/images/empty-geo-search.png'),
    logo: shopAsset('/images/7f-logo-monogram.svg'),
  },
  activities: { list: shopAsset('/images/7f-activities-placeholder.png') },
  newsletter: shopAsset('/images/newsletter-signup.svg'),
  emptyState: shopAsset('/images/empty-cart.png'),
}

type ImageProviderContextValue = typeof shop

const ImageProviderContext = createContext<ImageProviderContextValue | undefined>(undefined)

export function useImageProvider() {
  const context = useContext(ImageProviderContext)
  if (!context) {
    throw new Error('useImageProvider must be used within an ImageProvider')
  }
  return context
}

/**
 * Provides the image paths for components used in the shop app.
 */
export function ImageProvider({ children }: PropsWithChildren) {
  return <ImageProviderContext.Provider value={shop}>{children}</ImageProviderContext.Provider>
}
